/**
 * registry
 *
 * Shared store registry for dedup detection and test teardown.
 */

export const registry = new Map<string, { disconnect: () => void; forceDisconnect?: () => void }>();

export function clearStores(): void {
  for (const store of registry.values()) {
    if (store.forceDisconnect) {
      store.forceDisconnect();
    } else {
      store.disconnect();
    }
  }
  registry.clear();
}
